import {memo} from 'react'
import {ChevronLeft, ChevronRight} from 'lucide-react'
import {Button} from '@/shared/ui'
import {cn} from '@/shared/lib/cn'

interface PaginationProps {
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
}

const MAX_DOTS = 9

export const Pagination = memo(function Pagination({
  currentPage,
  totalPages,
  onPageChange,
}: PaginationProps) {
  if (totalPages <= 1) return null

  return (
    <div className="flex shrink-0 items-center justify-center gap-2 pt-1">
      <Button
        variant="ghost"
        size="icon-xs"
        className="text-muted-foreground hover:bg-muted hover:text-foreground disabled:opacity-30"
        disabled={currentPage === 0}
        onClick={() => onPageChange(currentPage - 1)}
      >
        <ChevronLeft />
      </Button>

      {totalPages <= MAX_DOTS ? (
        <div className="flex items-center gap-1.5">
          {Array.from({length: totalPages}, (_, i) => (
            <button
              key={i}
              className={cn(
                'size-1.5 rounded-full transition-all',
                i === currentPage
                  ? 'scale-[1.4] bg-foreground'
                  : 'bg-foreground/30 hover:bg-foreground/50',
              )}
              onClick={() => onPageChange(i)}
            />
          ))}
        </div>
      ) : (
        <span className="text-xs tabular-nums text-muted-foreground">
          {currentPage + 1} / {totalPages}
        </span>
      )}

      <Button
        variant="ghost"
        size="icon-xs"
        className="text-muted-foreground hover:bg-muted hover:text-foreground disabled:opacity-30"
        disabled={currentPage === totalPages - 1}
        onClick={() => onPageChange(currentPage + 1)}
      >
        <ChevronRight />
      </Button>
    </div>
  )
})
